// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","legend":"Bftvv","title":"VuYin","text":"cRsuB","image":"_2uYi3"};